function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Znajd\u017A na mapie");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h65v65H0z",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.95 55.601l-16.9-3.9-15.094 3.484a2.277 2.277 0 0 1-2.781-2.22v-36.4a2.275 2.275 0 0 1 1.609-2.18l16.266-5 13.826 4.245-1.733 1.135a8.757 8.757 0 0 0-3.968 7.336c0 3.767 5.8 10.9 8.775 14.169 2.975-3.269 8.775-10.405 8.775-14.17a8.711 8.711 0 0 0-3.965-7.322l-1.743-1.136 11.869-3.653a2.265 2.265 0 0 1 2.939 2.166v37.51a2.279 2.279 0 0 1-1.763 2.222zm-16.9-5.9l16.9 3.9 15.668-3.615a.327.327 0 0 0 .257-.324V12.155a.317.317 0 0 0-.411-.3l-8.113 2.5a10.656 10.656 0 0 1 3.324 7.752c0 5.707-9.611 15.844-10.02 16.273l-.7.74-.7-.74c-.41-.429-10.02-10.566-10.02-16.273a10.688 10.688 0 0 1 3.328-7.761l-9.5-2.92-15.703 4.82a.336.336 0 0 0-.235.319v36.4a.315.315 0 0 0 .123.259.3.3 0 0 0 .272.064z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.975 37.7h1.95v16.9h-1.95zm-16.9-27.3h1.95v40.3h-1.95z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.95 39.113l-.7-.74c-.41-.429-10.02-10.566-10.02-16.273a10.7 10.7 0 0 1 4.845-8.967 10.837 10.837 0 0 1 11.757.013 10.656 10.656 0 0 1 4.843 8.954c0 5.707-9.611 15.844-10.02 16.273zm0-25.788a8.787 8.787 0 0 0-8.775 8.775c0 3.767 5.8 10.9 8.775 14.169 2.98-3.268 8.775-10.4 8.775-14.169a8.711 8.711 0 0 0-3.965-7.322l-.01-.007a8.592 8.592 0 0 0-4.8-1.446z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.95 28.275a6.175 6.175 0 1 1 6.175-6.175 6.182 6.182 0 0 1-6.175 6.175zm0-10.4a4.225 4.225 0 1 0 4.225 4.225 4.23 4.23 0 0 0-4.225-4.225zm0 25.913l-16.9-4.174-16.666 4.117-.468-1.894 17.134-4.231 16.9 4.174 16.666-4.117.467 1.894z"
});

var SvgZnajdzNaMapie = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZnajdzNaMapie, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/znajdzNaMapie.96334fa5.svg";
export { ForwardRef as ReactComponent };